import { AxiosError } from 'axios'
import { Dictionary } from 'lodash'

export const isAuthErrored = ({ response }: AxiosError<Dictionary<string>>) =>
  response?.status === 500 && response.data.error === 'invalid_token'

export const isUnauthorizedError = ({
  response,
}: AxiosError<Dictionary<any>>) => {
  return (
    response?.status === 401 &&
    (response.data.error === "invalid_token" ||
      response.data.errors[0]?.errorType === "invalid_token")
  );
};